import { Checkbox } from 'antd';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import React, { useState } from 'react';
import { logout } from '../../../../../../utils/auth';
import message from '../../../../../../utils/message';
import './style.css';
import { usePrintReport } from '~/App/hooks';

const BottomBar = ({ id }: { id: string | undefined }) => {
  const [closingChecked, setClosingChecked] = useState(true);
  const onChangeClosing = (e: CheckboxChangeEvent) => {
    setClosingChecked(e.target.checked);
  };
  const [soldItemsChecked, setSoldItemsChecked] = useState(true);
  const onChangeSoldItems = (e: CheckboxChangeEvent) => {
    setSoldItemsChecked(e.target.checked);
  };
  const { printCashierReport, printCashierSoldItems } = usePrintReport();
  const onFinish = async () => {
    try {
      if (closingChecked && id) {
        await printCashierReport(id);
      }

      if (soldItemsChecked && id) {
        await printCashierSoldItems(id);
      }

      // Logout and navigate to login page when print success.
      logout();
    } catch (e: any) {
      message.error(`Gagal print laporan: ${e.message}`);
    }
  };

  return (
    <div>
      <div className="closing-bottom-bar-options">
        <Checkbox checked={closingChecked} onChange={onChangeClosing}>
          Print Laporan
        </Checkbox>
        <Checkbox checked={soldItemsChecked} onChange={onChangeSoldItems}>
          Print Sold Items
        </Checkbox>
      </div>
      <div className="closing-btn-finish" onClick={onFinish}>
        Selesai
      </div>
    </div>
  );
};

export default BottomBar;
